import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect, useMemo } from 'react';
import useCsrfToken from '../hooks/useCsrfToken';

export default function Tecnologiaall() {
    const { csrfToken } = useCsrfToken();
    const [tecnologia, setTecnologia] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [tags, setTags] = useState([]);

    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL;
        const transformData = (data) => {
            return data.map(item => ({
                id: item.id,
                image: `${API_URL}${item.primary_image}`,
                tag: 'Tecnología',
                name: item.title,
                slug: item.slug,
                desc: item.description.length > 100 ? item.description.substring(0, 100) + '...' : item.description,
                tags: item.tags,
            }));
        };
        if (csrfToken != null) {
            fetch(`${API_URL}/api/listings/technology`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    setTecnologia(transformData(data));
                    setIsLoading(false);
                })
                .catch(error => console.error('Error fetching data:', error));
            fetch(`${API_URL}/api/filtertags`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => setTags(data))
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [csrfToken]);

    const [selectedTag, setSelectedTag] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    const handleTagChange = (event) => {
        setSelectedTag(event.target.value);
    };
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };
    const filteredServices = useMemo(() => {
        return tecnologia.filter(item => {
            const matchesTag = selectedTag
                ? item.tags.some(tg => tg.pivot.tag_id === parseInt(selectedTag))
                : true;

            const normalizedName = removeAccents(item.name.toLowerCase());
            const normalizedDesc = removeAccents(item.desc.toLowerCase());
            const normalizedSearch = removeAccents(searchTerm.toLowerCase());

            const matchesSearchTerm =
                normalizedName.includes(normalizedSearch) ||
                normalizedDesc.includes(normalizedSearch);

            return matchesTag && matchesSearchTerm;
        });
    }, [tecnologia, selectedTag, searchTerm]);

    return (
        <>
            <div className="row justify-content-center bg-inverted py-2">
                <div className="col-12 col-md-3">
                    <select name="specialties" className='form-control' data-no-translation onChange={handleTagChange}>
                        <option value="">Filtrar por área o especialidad</option>
                        <option value="">-Todo-</option>
                        {tags.map((tg, index) => (
                            <option key={index} value={tg.id}>{tg.title}</option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md-3">
                    <input name="searchfield" type="text" className='form-control' placeholder='Buscar...' onChange={handleSearchChange} />
                </div>
            </div>
            <div className="row">
                {filteredServices.length > 0 ? (
                    filteredServices.map((item, index) => {
                        const stripTags = (html) => {
                            let doc = new DOMParser().parseFromString(html, 'text/html');
                            return doc.body.textContent || "";
                        };
                        return (
                            <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                                <div className="listing position-relative overflow-hidden shadow rounded p-4 d-flex flex-column h-100">
                                    <div className="position-relative">
                                        <div className="listing-image position-relative overflow-hidden rounded shadow object-fit-cover">
                                            <Link to={`/tecnologia-equipamiento/${item.slug}`}>
                                                <img src={item.image} className="img-fluid" alt={item.name} />
                                            </Link>
                                        </div>

                                        <div className="position-absolute top-100 start-0 translate-middle-y ms-2">
                                            <span className="badge bg-secondary">{item.tag}</span>
                                        </div>
                                    </div>

                                    <div className="pt-4 flex-grow-1 d-flex flex-column">
                                        <Link to={`/tecnologia-equipamiento/${item.slug}`} className="text-dark title h5">{item.name}</Link>

                                        <p className="text-muted my-2 flex-grow-1">{stripTags(item.desc)}</p>

                                        <Link to={`/tecnologia-equipamiento/${item.slug}`} className="btn btn-success w-100 btn-sm text-light mt-auto hv:bg-secondary">Conocer más <i className="mdi mdi-chevron-right align-middle"></i></Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                ) : (
                    <div className="col-12 mt-4 pt-2 text-center">
                        {isLoading ? (
                            <p className="text-muted">Cargando...</p>
                        ) : (
                            <p className="text-muted">No hay instalaciones o equipamiento aquí publicados con esa característica, contáctenos para más información.</p>
                        )}
                    </div>
                )}
            </div>
        </>
    )
}
